export { default as FreePageLayout } from './FreePageLayout.vue';
